import React from 'react';
import { Form } from 'formik';
import { FormikField } from '../../../../components/FormikField';
import { Divider } from 'primereact/divider';
import styles from './BillingAgreementForm.styles.scss';
import cn from 'classnames';
import { Button } from 'primereact/button';
import DataTable from '../../../../components/shared/DataTable/DataTable';
import { AGREEMENT_TYPE } from '../../config/constants';
import i18n from '../../../../config/i18n';
import moment from 'moment';

const BillingAgreementForm = ({
  values,
  errors,
  touched,
  formConfig,
  termsAndConditionsFieldConfig,
  actionButtons,
  addToTable,
  agreements,
  submitForm,
  setValues,
  removeAgreement,
  editAgreement,
  isUpdateValue,
  isValid,
  createAs,
  agreementType,
  isDraft,
  formActionsStyles,
  hideMoreAgreements = false,
}) => {
  return (
    <Form className={styles.billingForm}>
      {formConfig.map((section, index) => (
        <div className={'mb-5'} key={section.title}>
          <div className="d-flex flex-row justify-content-between align-items-center mb-4">
            <h2>{section.title}</h2>
            {index == 0 && values.referenceNumber && (
              <div>
                <span className={styles.referenceNumber}>
                  {i18n.t('special_billing.reference-number')}:{' '}
                </span>
                <span className={styles.referenceNumberValue}>
                  {values.referenceNumber}
                </span>
              </div>
            )}
          </div>
          <div className={styles.formSection}>
            {section.fields
              .filter((item) => !item.hide)
              .map((field) => (
                <div key={field.name} className={styles.fieldWrapper}>
                  <FormikField
                    {...field}
                    name={field.name}
                    component={field.component}
                    error={errors[field.name]}
                    showError={isDraft || field.isTouched}
                    componentProps={{
                      ...field.componentProps,
                      className: cn(
                        field.componentProps?.className,
                        !values[field.name] ? styles.emptyField : '',
                        errors[field.name] && touched[field.name]
                          ? styles.errorField
                          : '',
                      ),
                    }}
                  />
                </div>
              ))}
          </div>
        </div>
      ))}
      {addToTable && (
        <>
          {isUpdateValue > -1 ? (
            <Button
              className="m-2"
              label="Update"
              type="button"
              onClick={() => {
                setValues({ ...values, isTable: true });
                submitForm();
              }}
              disabled={!isValid}
            />
          ) : (
            <Button
              className="m-2"
              label="Add to list"
              type="button"
              onClick={() => {
                setValues({ ...values, isTable: true });
                submitForm();
              }}
              disabled={!isValid}
            />
          )}
          <DataTable
            // loading={tableLoading}
            emptyMessage={<></>}
            value={agreements}
            showIndex
            columns={() =>
              [
                agreementType === AGREEMENT_TYPE.SELF && {
                  label: 'special_billing.buyer-name',
                  value: 'buyerName',
                  sortable: false,
                },
                agreementType === AGREEMENT_TYPE.SELF && {
                  label: 'special_billing.buyer-vat-account-number',
                  value: 'buyerVatNumber',
                  sortable: false,
                },
                agreementType === AGREEMENT_TYPE.SELF && {
                  label: 'special_billing.buyer-phone-number',
                  value: 'buyerPhoneNumber',
                  sortable: false,
                },
                agreementType === AGREEMENT_TYPE.SELF && {
                  label: 'special_billing.buyer-email',
                  value: 'buyerEmail',
                  sortable: false,
                },

                agreementType === AGREEMENT_TYPE.THIRD && {
                  label: 'special_billing.thirdParty-name',
                  value: 'thirdPartyName',
                  sortable: false,
                },
                agreementType === AGREEMENT_TYPE.THIRD && {
                  label: 'special_billing.thirdParty-phone-number',
                  value: 'thirdPartyPhoneNumber',
                  sortable: false,
                },
                agreementType === AGREEMENT_TYPE.THIRD && {
                  label: 'special_billing.thirdParty-email',
                  value: 'thirdPartyEmail',
                  sortable: false,
                },

                {
                  label: 'special_billing.agreement-start-date',
                  value: 'agreementStartDate',
                  sortable: false,
                  body: (rowdata) => {
                    return moment(rowdata.agreementStartDate).format(
                      'DD MMM YYYY',
                    );
                  },
                },
                {
                  label: 'special_billing.agreement-end-date',
                  value: 'agreementEndDate',
                  body: (rowdata) => {
                    return moment(rowdata.agreementEndDate).format(
                      'DD MMM YYYY',
                    );
                  },
                  sortable: false,
                },
                {
                  label: 'special_billing.note',
                  value: 'note',
                  sortable: false,
                },
                {
                  label: i18n.t('common.actions'),
                  value: 'actions',
                  body: (rowdata, options) => (
                    <div className="d-flex gap-2">
                      <Button
                        icon="pi pi-pen-to-square"
                        rounded
                        type="button"
                        onClick={() => {
                          editAgreement(rowdata, options.rowIndex);
                        }}
                      />
                      <Button
                        icon="pi pi-trash"
                        rounded
                        type="button"
                        onClick={() => {
                          removeAgreement(options.rowIndex);
                        }}
                      />
                    </div>
                  ),
                },
              ].filter(Boolean)
            }
            dataKey="id"
          />
        </>
      )}
      <Divider className="my-4" />
      <div className={'mb-5'}>
        {!addToTable && !hideMoreAgreements && (
          <Button
            className={styles.addMoreBtn}
            label="Add more agreement(s)"
            icon="pi pi-plus-circle"
            text
            type="button"
            disabled={!isValid}
            onClick={() => {
              setValues({ ...values, isTable: true });
              submitForm();
            }}
          />
        )}
        {termsAndConditionsFieldConfig && (
          <FormikField
            name={termsAndConditionsFieldConfig.name}
            error={errors[termsAndConditionsFieldConfig.name]}
            showError={true}
            {...termsAndConditionsFieldConfig}
          />
        )}
      </div>
      <div className={cn(styles.formActions, formActionsStyles)}>
        {actionButtons}
      </div>
    </Form>
  );
};

export default BillingAgreementForm;
